import { render, staticRenderFns } from "./MapaInfluencia.vue?vue&type=template&id=0b8201e6&"
import script from "./MapaInfluencia.vue?vue&type=script&lang=js&"
export * from "./MapaInfluencia.vue?vue&type=script&lang=js&"
import style0 from "./MapaInfluencia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports